<template>
	<div  class="home flex start-v">
		<div class="tabs flex">
			<span v-throttle @click="params.type=0" :class="{'active':params.type==0}">跑&emsp;步</span>
			<!-- <span v-throttle @click="params.type=1" :class="{'active':params.type===1}">立定跳远</span> -->
		</div>

		<div class="tips flex center">
			<p>
				您当前的分组为
				<span :style="{color:currentGroupColor}">{{currentGroup}}</span>
				，建议练习{{currentGroup}}的体感视频
			</p>
		</div>

		<div v-bottom="nextPage" class="list">
			<div @click="$router.push(`/student/sports/kinect/details?kinectId=${item.id}`)" v-for="(item,index) in videosList" :key="index" class="card flex between">
				<img :src="item.cover" alt />
				<div class="flex between-v">
					<p class="text-ellipsis">{{item.name}}</p>
					<span>适合 <span :style="{color:groupColorList[item.studentGroup]}">{{groupList[item.studentGroup]}}</span> 训练</span>
				</div>
			</div>
			<div v-if="endPage" class="scroll-end"></div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			groupList: ["不及格组", "提高组", "高级组"],
			groupColorList: [
				"rgba(254, 198, 51, 1)",
				"rgba(255, 162, 22, 1)",
				"rgba(255, 111, 0, 1)",
			],
			params: {
				pageNo: 1,
				pageSize: 10,
				type: 0,
			},
			pages: 0,
			videosList: [],
			currentTab: 0,
		};
	},

	computed: {
		currentGroup() {
			// console.log('this.$store.state',this.$store.state);
			return this.groupList[this.$store.state.groupType];
		},
		currentGroupColor() {
			return this.groupColorList[this.$store.state.groupType];
		},
		endPage() {
			return this.pages && this.pages === this.params.pageNo;
		},
	},

	watch: {
		"params.type": {
			handler(newValue) {
				this.params.pageNo = 1;
				this.pages = 0;
				this.videosList = [];
				this.getVideosList();
			},
			immediate: true,
		},
	},

	methods: {
		nextPage() {
			if (this.endPage) return;
			this.params.pageNo++;
			this.getVideosList();
		},
		async getVideosList() {
			console.log(this.params);
			try {
				let {success,message,result} = await this.$http.get(`h5/general/listAiVideoCollection`,{params:this.params})
				if(!success) throw new Error(message)
				this.pages = result.pages;
				this.videosList = this.videosList.concat(result.records);
			} catch (error) {
				console.log("getVideosList", error?.message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.home {
	height: 100%;
	padding: 17 / @rem 17 / @rem 0;
	.tabs {
		width: 100%;
		padding-bottom: 24 / @rem;
		font-size: 17 / @rem;
		font-weight: bold;
		color: rgba(31, 30, 29, 0.3);
		span {
			position: relative;
			&.active {
				color: rgba(31, 30, 29, 1);
				&::before {
					content: "";
					display: block;
					width: 72 / @rem;
					height: 8 / @rem;
					border-radius: 5 / @rem;
					background: linear-gradient(
						270deg,
						#ffffff 0%,
						#ffa216 100%
					);
					position: absolute;
					bottom: -10 / @rem;
					left: 0 / @rem;
				}
			}
		}
	}

	.tips {
		width: 100%;
		min-height: 37 / @rem;
		font-size: 12 / @rem;
		box-shadow: 0 3 / @rem 17 / @rem 0 rgba(143, 72, 0, 0.2);
		border-radius: 12 / @rem;
		span {
			font-size: 14 / @rem;
			color: rgba(255, 185, 0, 1);
		}
	}

	.list {
		flex: 1;
		width: 100%;
		height: 100%;
		overflow-y: auto;
		.card {
			height: 70 / @rem;
			margin: 17 / @rem 0;
			img {
				width: 126 / @rem;
				height: 100%;
				background-color: gray;
				border-radius: 2 / @rem;
			}
			> div {
				flex: 1;
				height: 100%;
				padding: 10 / @rem 0 10 / @rem 13 / @rem;
				align-items: flex-start;
				overflow: hidden;
				p {
					width: 100%;
					font-size: 17 / @rem;
					font-weight: bold;
				}
				span {
					// display: block;
					padding: 3 / @rem 0;
					border-radius: 3 / @rem;
					font-size: 12 / @rem;
					// background-color: rgba(254, 198, 51, 0.2);
					// color: rgba(254, 198, 51, 1);
				}
			}
		}
	}
}
</style>
